module.exports = __webpack_public_path__ + "static/media/shapes.3c1d7812.svg";